// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"ManageWordsLoader_loadingContainer__38WSw","comment":"ManageWordsLoader_comment__3qiCJ"};